import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'bl-resumo-guias-rede-propria-action-cell',
    template: `
    <div class="flex justify-content-between">
      <div class="overflow-hidden">{{ displayValue }}</div>
      @if (!params.node.rowPinned && !params.node.footer) {
        <div [pTooltip]="tooltipText" tooltipPosition="right">
          <button
            pButton
            type="button"
            icon="pi pi-list"
            class="p-button-sm p-button-text p-0 flex-shrink-0"
            style="vertical-align: baseline"
            [disabled]="!hasGuides"
            (click)="onButtonClick()"
          ></button>
        </div>
      }
    </div>
    `,
    standalone: false
})
export class ResumoGuiasRedePropriaActionCellRenderer implements ICellRendererAngularComp {
  params: ICellRendererParams;
  value: string;
  displayValue: string;
  hasGuides = false;
  tooltipText: string = 'Listar Guias';

  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.updateValue(params);
  }

  refresh(params: ICellRendererParams) {
    this.updateValue(params);
    return true;
  }

  private numeric(val: any): number {
    const n = typeof val === 'string' ? Number(val.replace(/\D+/g, '')) : Number(val);
    return isNaN(n) ? 0 : n;
  }

  updateValue(params: ICellRendererParams) {
    this.params = params;
    this.value = params.value;
    this.displayValue = params.valueFormatted ?? params.value;
    this.hasGuides = this.numeric(this.value) > 0;

    if (this.hasGuides) {
      this.tooltipText = 'Listar Guias';
    } else {
      this.tooltipText = 'Não há guias disponíveis';
    }
  }

  onButtonClick() {
    let rowData: any;

    const colDef = this.params.column?.getColDef?.();
    const pivotKeys = (colDef as any)?.pivotKeys as string[] | undefined;
    const competenciaFromPivot = pivotKeys?.find(k => /^\d{6}$/.test(k)) ?? pivotKeys?.[pivotKeys.length - 1];
    const tipoRedeFromPivot = pivotKeys?.find(k => /^(D|I)\s-\s/.test(k));
    const tpRedeFromPivot = tipoRedeFromPivot ? tipoRedeFromPivot.charAt(0) : undefined;

    if (this.params.node.group) {
      const currentGroupData = this.params.node.groupData || {};
      const parentGroupData = this.params.node.parent?.groupData || {};

      const getValueFromHierarchy = (key: string) => {
        let value = currentGroupData[key];
        if (value !== undefined && value !== null) return value;

        value = parentGroupData[key];
        if (value !== undefined && value !== null) return value;

        const keysToTraverse = [
          'ag-Grid-AutoColumn-cnpj_prestador',
          'ag-Grid-AutoColumn-nome_prestador',
          'ag-Grid-AutoColumn-nm_id_origem_guia',
          'ag-Grid-AutoColumn-origem_guia',
          'ag-Grid-AutoColumn-tp_rede',
          'ag-Grid-AutoColumn-nr_cnes_exec',
          'ag-Grid-AutoColumn-tp_guia',
          'ag-Grid-AutoColumn-nm_tp_rede',
          'ag-Grid-AutoColumn-nm_tp_guia',
          'ag-Grid-AutoColumn-amostra_nr_guia_operadora',
          'ag-Grid-AutoColumn-nr_competencia',
        ];

        if (keysToTraverse.includes(key)) {
          let ancestor = this.params.node.parent?.parent;
          while (ancestor) {
            const ancestorData = ancestor.groupData || {};
            value = ancestorData[key];
            if (value !== undefined && value !== null) return value;
            ancestor = ancestor.parent;
          }
        }

        return parentGroupData[key];
      };

      rowData = {
        cnpj_prestador: getValueFromHierarchy('ag-Grid-AutoColumn-cnpj_prestador'),
        nome_prestador: getValueFromHierarchy('ag-Grid-AutoColumn-nome_prestador'),
        origem_guia:
          getValueFromHierarchy('ag-Grid-AutoColumn-nm_id_origem_guia') ??
          getValueFromHierarchy('ag-Grid-AutoColumn-origem_guia'),
        tp_rede: getValueFromHierarchy('ag-Grid-AutoColumn-tp_rede'),
        nr_cnes_exec: getValueFromHierarchy('ag-Grid-AutoColumn-nr_cnes_exec'),
        tp_guia: getValueFromHierarchy('ag-Grid-AutoColumn-tp_guia'),
        nm_tp_rede: getValueFromHierarchy('ag-Grid-AutoColumn-nm_tp_rede'),
        nm_tp_guia: getValueFromHierarchy('ag-Grid-AutoColumn-nm_tp_guia'),
        amostra_nr_guia_operadora: getValueFromHierarchy('ag-Grid-AutoColumn-amostra_nr_guia_operadora'),
        nr_competencia: getValueFromHierarchy('ag-Grid-AutoColumn-nr_competencia'),
        qtde_guia: currentGroupData['ag-Grid-AutoColumn-qtde_guia'],
        vl_informado: currentGroupData['ag-Grid-AutoColumn-vl_informado'],
        vl_glosa: currentGroupData['ag-Grid-AutoColumn-vl_glosa'],
        vl_pago: currentGroupData['ag-Grid-AutoColumn-vl_pago'],
      };
    } else {
      rowData = this.params.node.data;
    }

    if (!rowData?.nr_competencia && competenciaFromPivot) {
      rowData = { ...rowData, nr_competencia: competenciaFromPivot };
    }

    if (!rowData?.tp_rede) {
      const nm = rowData?.nm_tp_rede ?? tipoRedeFromPivot;
      const first = typeof nm === 'string' ? nm.trim().charAt(0) : undefined;
      if (first === 'D' || first === 'I') {
        rowData = { ...rowData, tp_rede: first };
      }
    }

    if (!rowData) {
      console.error('Row data is undefined or could not be constructed.');
      return;
    }

    const rowIndex = this.params.node?.rowIndex;
    this.params.context.parentComponent.showDialogFor(rowData, rowIndex);
  }
}
